import {lazy} from 'react'

const TreeMyBalanceScreen = lazy(
  () => import(/* webpackChunkName: 'MyBalance' */ './TreeMyBalanceScreen'),
)

export {TreeMyBalanceScreen}
